import { parseTemplate } from 'url-template';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export default function removeUserProductGroup(client: ApiClient, userId: string, id: string): Promise<void> {
	const url = parseTemplate('users/{userId}/product-groups/{id}');
	return client
		.fetch(url.expand({ userId, id }), { method: 'DELETE' })
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
